import React, { useEffect, useLayoutEffect } from 'react'
import { connect } from 'react-redux'
import { IconButton } from '@chakra-ui/react'
import { onToggleSideNav } from 'redux/actions/app.actions'
import {
  IconExpand,
  IconCollapse,
} from '_base/Icon'

let width = document.documentElement.clientWidth

function ToggleSideNav({ isMobile, isExpandedSideNav, onToggleSideNav }) {
  useEffect(() => {
    const navWidth = isExpandedSideNav ? 220 : 64
    const containerWidth = document.documentElement.clientWidth - navWidth

    document.documentElement.style.setProperty('--side-nav-width', navWidth + 'px')
    document.documentElement.style.setProperty('--container-width', containerWidth + 'px')
  }, [isExpandedSideNav])

  useLayoutEffect(() => {
    function updateSize() {
      if (document.documentElement.clientWidth !== width) {
        width = document.documentElement.clientWidth
        const navWidth = isExpandedSideNav ? 220 : 64
        document.documentElement.style.setProperty('--container-width', (width - navWidth) + 'px')
      }
    }
    window.addEventListener('resize', updateSize)
    updateSize()
    return () => window.removeEventListener('resize', updateSize)
  }, [isExpandedSideNav])

  if (isMobile) return null
  return (
    <IconButton
      aria-label={isExpandedSideNav ? 'collapse sidebar' : 'expand sidebar'}
      pos="absolute"
      bottom="0"
      right="16px"
      variant="ghost"
      w="32px"
      minW="32px"
      icon={isExpandedSideNav ? <IconCollapse /> : <IconExpand />}
      onClick={onToggleSideNav}
    />
  )
}

const mapStateToProps = state => {
  return {
    isExpandedSideNav: state.app.isExpandedSideNav
  }
}

export default connect(mapStateToProps, {
  onToggleSideNav
})(ToggleSideNav)
